import BaseHeading from './BaseHeading'
import type { ReactNode } from 'react'

interface PropsType {
  children: ReactNode
}

const EmphasisHeading = (props: PropsType) => <BaseHeading $borderColor="#ec4444">{props.children}</BaseHeading>

export default EmphasisHeading
